module.exports = __webpack_public_path__ + "img/chargingpoint-rejected.74199f24.png";